import React from "react";
import { useSelector } from "react-redux";
import { Outlet, Navigate } from "react-router-dom";

export default function MuthootGoldLayout() {
  const productType = useSelector((state) => state.token.productType);

  if (productType !== "Gold Loans") {
    // not the correct product type, redirect to products
    return <Navigate to={`/products`} />;
  }

  return <Outlet />;
}
